module.exports = __webpack_public_path__ + "img/home-graphic-nl-BE.22b09cd1.png";